import { useEffect, useMemo, useState } from "react";
import { Option } from "../../../types/types";
import useApi from "../useApi";
import { toast } from "react-toastify";
import webservice_url, { master_baseUrl } from "../../webservice/Webservice_url";

interface dataTypes {
    department_id: string;
    department_code: string;
    department_name: string;
}

// departments by program id
export function useDepartmentByProgramId(programId: string) {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>("", {
        method: "GET",
        autoCall: false,
        handleGlobalError: false,
    });


    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.department_name,
            value: d?.department_id ?? "",
        }))
    }, [dataList])


    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi(undefined,
                `${master_baseUrl}/programs/${programId}/departments`,);
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err)
        }
    }

    useEffect(() => {
        if (!programId) {
            setDataList([]);
            return;
        }
        fetchData();
    }, [programId]);

    return { dataList, options, loading };
}


// multidepartmenthooks
export function useDepartmentByMultiProgramId(programId: string) {
    const [dataList, setDataList] = useState<dataTypes[]>([]);

    // API
    const { callApi, loading, error } = useApi<any>(webservice_url.getDepartmentByMultiProgram, {
        method: "POST",
        autoCall: false,
        handleGlobalError: false,
    });

    const options = useMemo<Option[] | []>(() => {
        if (!dataList?.length) return [];

        return dataList?.map((d) => ({
            label: d?.department_name,
            value: d?.department_id ?? "",
        }))
    }, [dataList])


    //   fetch data 
    const fetchData = async () => {
        try {
            const res = await callApi({
                programIds: programId
            });
            setDataList(Array.isArray(res) ? res : (res?.data ?? []));
        } catch (err: any) {
            setDataList([]);
            console.error(err)
        }
    }

    useEffect(() => {
        if (!programId.length) {
            setDataList([]);
            return;
        }
        fetchData(); 
    }, [programId]);

    return { dataList, options, loading };
}